/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  //Chip,
  Divider,
  Drawer,
  Hidden,
  Link,
  List,
  ListSubheader,
  Typography,
  makeStyles
} from '@material-ui/core';
import { custMenu } from 'src/constants';
import Logo from 'src/components/Logo';
import NavItem from './NavItem';
import { useTranslation } from 'react-i18next'


function renderNavItems({ items, rolNeed, ...rest }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => ReduceChildRoutes({ acc, item, rolNeed, ...rest }),
        []
      )}
    </List>
  );
}

function ReduceChildRoutes({
  acc,
  pathname,
  item,
  depth = 0,
  rolNeed,
  userRol
}) {
  const key = item.title + depth;
  const { t } = useTranslation();

  if (item.items) {
    const open = matchPath(pathname, {
      path: t(item.href),
      exact: false
    });

    // if (item.title === 'customMenu.navBar.general.maps.title') {
    //   debugger;
    // }

    if ((rolNeed >= userRol || rolNeed === undefined) && (item.rolNeed >= userRol || item.rolNeed === undefined)) {
      acc.push(
        <NavItem
          depth={depth}
          icon={item.icon}
          key={key}
          info={item.info}
          open={Boolean(open)}
          title={t(item.title)}
        >
          {renderNavItems({
            depth: depth + 1,
            pathname,
            rolNeed,
            userRol,
            items: item.items
          })}
        </NavItem>
      );
    }
  } else {
    // if (item.title === 'customMenu.navBar.general.maps.title') {
    //   debugger;
    // }
    //console.log('depth:' + depth + ' - Title:' + item.title + ' - rolNeed:' + rolNeed + ' - userRol:' + userRol)
    if (item.rolNeed >= userRol || item.rolNeed === undefined) {
      acc.push(
        <NavItem
          depth={depth}
          href={t(item.href)}
          icon={item.icon}
          key={key}
          info={item.info}
          title={t(item.title)}
        />
      );
    }
  }

  return acc;
}

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

function NavBar({ openMobile, onMobileClose, }) {
  const classes = useStyles();
  const location = useLocation();
  const { user } = useSelector((state) => state.account);
  const { t } = useTranslation();
  const myLogoStyle = {
    width: '193px'
  }

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box
            p={2}
            display="flex"
            justifyContent="center"
            bac
          >
            <RouterLink to="/">
              <Logo style={myLogoStyle} />
            </RouterLink>
          </Box>
        </Hidden>
        <Box p={2}>
          <Box
            display="flex"
            justifyContent="center"
          >
            <RouterLink to="/app/account">
              <Avatar
                alt="User"
                className={classes.avatar}
                src={!user ? '' : user.user.avatar}
              />
            </RouterLink>
          </Box>
          <Box
            mt={2}
            textAlign="center"
          >
            <Link
              component={RouterLink}
              to="/app/account"
              variant="h5"
              color="textPrimary"
              underline="none"
            >
              {!user ? '' : `${user.user.firstName} ${user.user.lastName}`}
            </Link>
            <Typography
              variant="body2"
              color="textSecondary"
            >
              {!user ? '' : user.user.rolDesc}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
            >
              {!user ? '' : user.projects[0].projectDesc}
            </Typography>
          </Box>
        </Box>
        <Divider />
        <Box p={2}>
          {custMenu.map((config) => {
            if (config.rolNeed >= (!user ? '' : user.user.rolId) || config.rolNeed === undefined) {
              return (
                <List
                  key={t(config.subheader)}
                  subheader={(
                    <ListSubheader
                      disableGutters
                      disableSticky
                    >
                      {t(config.subheader)}
                    </ListSubheader>
                  )}
                >
                  {renderNavItems({ items: config.items, pathname: location.pathname, rolNeed: config.rolNeed, userRol: (!user ? '' : user.user.rolId) })}
                </List>
              )
            } else {
              return (null)
            }
          })}
        </Box>
        <Divider />
        <Box p={2}>
          <Box
            p={2}
            borderRadius="borderRadius"
            bgcolor="background.dark"
          >
            <Typography
              variant="h6"
              color="textPrimary"
            >
              {t('global.needHelp')}
            </Typography>
            <Link
              variant="subtitle1"
              color="secondary"
              component={RouterLink}
              to="/contact"
            >
              {t('global.checkSite')}
            </Link>
          </Box>
        </Box>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
